export const QualityGameStyles = `
    .UFOV-brain-games__screen {
        position: relative;
    }

    .UFOV-brain-games__button.is-correct {
        background: #e5f8ef;
        box-shadow: 0 0 0 4px rgba(32, 164, 107, 0.16);
        color: #176f4a;
    }

    .UFOV-brain-games__button.is-wrong {
        background: #ffe7ec;
        box-shadow: 0 0 0 4px rgba(233, 85, 105, 0.14);
        color: #9b304a;
    }

    .UFOV-brain-games__color-button.is-correct {
        box-shadow: 0 0 0 6px rgba(32, 164, 107, 0.22), 0 12px 22px rgba(38, 48, 79, 0.1);
    }

    .UFOV-brain-games__color-button.is-picked:not(.is-correct) {
        box-shadow: 0 0 0 6px rgba(233, 85, 105, 0.2), 0 12px 22px rgba(38, 48, 79, 0.1);
    }

    .UFOV-brain-games__shelf-game,
    .UFOV-brain-games__balance-game,
    .UFOV-brain-games__percent-game {
        align-items: center;
        display: grid;
        gap: 22px;
        justify-items: center;
        justify-self: center;
        width: min(360px, 100%);
    }

    .UFOV-brain-games__shelf-preview {
        display: grid;
        gap: 9px;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        width: min(318px, 100%);
    }

    .UFOV-brain-games__shelf-card {
        aspect-ratio: 0.82;
        perspective: 700px;
    }

    .UFOV-brain-games__shelf-card-inner {
        display: block;
        height: 100%;
        position: relative;
        transform-style: preserve-3d;
        transition: transform 520ms cubic-bezier(0.2, 0.8, 0.2, 1);
        width: 100%;
    }

    .UFOV-brain-games__shelf-game.is-answer .UFOV-brain-games__shelf-card-inner,
    .UFOV-brain-games__shelf-game.is-feedback .UFOV-brain-games__shelf-card-inner {
        transform: rotateY(180deg);
    }

    .UFOV-brain-games__shelf-face {
        align-items: center;
        backface-visibility: hidden;
        background: #ffffff;
        border: 1px solid rgba(31, 41, 55, 0.08);
        border-radius: 14px;
        box-shadow: 0 10px 22px rgba(31, 41, 55, 0.09);
        display: flex;
        inset: 0;
        justify-content: center;
        position: absolute;
    }

    .UFOV-brain-games__shelf-face.is-back {
        background: #2f6fed;
        transform: rotateY(180deg);
    }

    .UFOV-brain-games__shelf-face.is-back::after {
        background: url('/assets/ufov/sopt-mark-white.svg') center / contain no-repeat;
        content: '';
        height: 38%;
        opacity: 0.95;
        width: 38%;
    }

    .UFOV-brain-games__shelf-face img,
    .UFOV-brain-games__shelf-options img {
        height: 78%;
        object-fit: contain;
        width: 78%;
    }

    .UFOV-brain-games__shelf-options,
    .UFOV-brain-games__quality-options {
        display: grid;
        gap: 10px;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        width: min(318px, 100%);
    }

    .UFOV-brain-games__shelf-options {
        opacity: 0;
        pointer-events: none;
        transform: translateY(8px);
        transition: opacity 240ms ease, transform 240ms ease;
    }

    .UFOV-brain-games__shelf-game.is-answer .UFOV-brain-games__shelf-options,
    .UFOV-brain-games__shelf-game.is-feedback .UFOV-brain-games__shelf-options {
        opacity: 1;
        pointer-events: auto;
        transform: translateY(0);
    }

    .UFOV-brain-games__shelf-options button,
    .UFOV-brain-games__quality-options button {
        align-items: center;
        background: #ffffff;
        border: 1px solid rgba(31, 41, 55, 0.08);
        border-radius: 16px;
        box-shadow: 0 10px 22px rgba(31, 41, 55, 0.08);
        color: #15243d;
        display: flex;
        font: inherit;
        font-size: 24px;
        font-weight: 600;
        justify-content: center;
        min-height: 72px;
    }

    .UFOV-brain-games__shelf-options button {
        aspect-ratio: 1.45;
        padding: 5px;
    }

    .UFOV-brain-games__shelf-options button.is-correct,
    .UFOV-brain-games__quality-options button.is-correct {
        background: #e5f8ef;
        box-shadow: 0 0 0 4px rgba(32, 164, 107, 0.16);
    }

    .UFOV-brain-games__shelf-options button.is-picked:not(.is-correct),
    .UFOV-brain-games__quality-options button.is-picked:not(.is-correct) {
        background: #ffe7ec;
        box-shadow: 0 0 0 4px rgba(233, 85, 105, 0.14);
    }

    .UFOV-brain-games__balance-scale {
        height: 190px;
        position: relative;
        width: min(318px, 100%);
    }

    .UFOV-brain-games__balance-beam {
        background: #243652;
        border-radius: 999px;
        box-shadow: 0 4px 9px rgba(36, 54, 82, 0.14);
        height: 9px;
        left: 7%;
        position: absolute;
        right: 7%;
        top: 34px;
        transform-origin: center;
        z-index: 3;
    }

    .UFOV-brain-games__balance-stand {
        background: #243652;
        border-radius: 0 0 6px 6px;
        bottom: 23px;
        left: calc(50% - 6px);
        position: absolute;
        top: 39px;
        width: 12px;
        z-index: 1;
    }

    .UFOV-brain-games__balance-stand::before {
        background: #243652;
        border: 3px solid #ffffff;
        border-radius: 50%;
        box-shadow: 0 3px 8px rgba(36, 54, 82, 0.14);
        content: '';
        height: 18px;
        left: -6px;
        position: absolute;
        top: -12px;
        width: 18px;
        z-index: 4;
    }

    .UFOV-brain-games__balance-stand::after {
        background: #243652;
        border-radius: 999px;
        bottom: -9px;
        box-shadow: 0 5px 11px rgba(36, 54, 82, 0.13);
        content: '';
        height: 13px;
        left: -38px;
        position: absolute;
        width: 88px;
    }

    .UFOV-brain-games__balance-pan {
        height: 104px;
        position: absolute;
        top: 39px;
        width: 122px;
        z-index: 2;
    }

    .UFOV-brain-games__balance-pan.is-left { left: 0; }
    .UFOV-brain-games__balance-pan.is-right { right: 0; }

    .UFOV-brain-games__balance-suspension {
        height: 1px;
        left: 50%;
        position: absolute;
        top: 0;
        width: 1px;
        z-index: 0;
    }

    .UFOV-brain-games__balance-suspension::before,
    .UFOV-brain-games__balance-suspension::after {
        background: #9aa6b7;
        border-radius: 999px;
        content: '';
        height: 106px;
        left: -1px;
        position: absolute;
        top: 0;
        transform-origin: 50% 0;
        width: 2px;
    }

    .UFOV-brain-games__balance-suspension::before {
        transform: rotate(34deg);
    }

    .UFOV-brain-games__balance-suspension::after {
        transform: rotate(-34deg);
    }

    .UFOV-brain-games__balance-weights {
        align-items: flex-end;
        bottom: 14px;
        display: flex;
        gap: 6px;
        justify-content: center;
        left: 6px;
        position: absolute;
        right: 6px;
        z-index: 2;
    }

    .UFOV-brain-games__balance-weights span {
        align-items: center;
        background: #ffda60;
        border: 2px solid #efbd31;
        border-radius: 10px;
        box-shadow: 0 4px 9px rgba(65, 72, 91, 0.1);
        color: #25344e;
        display: flex;
        font-size: 22px;
        font-weight: 600;
        height: 43px;
        justify-content: center;
        width: 44px;
    }

    .UFOV-brain-games__balance-weights span.is-negative {
        background: #8fdcf4;
        border-color: #42b9df;
    }

    .UFOV-brain-games__balance-pan .UFOV-brain-games__balance-weights span.is-unknown {
        background: #ffffff;
        border-color: #8d99ab;
        border-style: dashed;
        box-shadow: none;
    }

    .UFOV-brain-games__balance-tray {
        background: #ffffff;
        border: 1px solid #d8dee8;
        border-radius: 4px 4px 28px 28px;
        bottom: 0;
        box-shadow: 0 7px 15px rgba(31, 41, 55, 0.09);
        height: 15px;
        left: 0;
        position: absolute;
        right: 0;
        z-index: 1;
    }

    .UFOV-brain-games__play.is-good .UFOV-brain-games__balance-scale {
        animation: UFOV-balance-settle 460ms ease;
    }

    .UFOV-brain-games__play.is-miss .UFOV-brain-games__balance-scale {
        animation: UFOV-balance-wobble 420ms ease;
    }

    .UFOV-brain-games__percent-game > strong {
        align-items: center;
        background: #ffd44a;
        border-radius: 999px;
        color: #22324d;
        display: flex;
        font-size: 34px;
        font-weight: 600;
        height: 94px;
        justify-content: center;
        width: 94px;
    }

    .UFOV-brain-games__percent-dots {
        background: #ffffff;
        border: 1px solid rgba(31, 41, 55, 0.08);
        border-radius: 18px;
        box-shadow: 0 12px 26px rgba(31, 41, 55, 0.08);
        display: grid;
        gap: 9px;
        grid-template-columns: repeat(var(--dot-columns), 24px);
        justify-content: center;
        padding: 20px;
    }

    .UFOV-brain-games__percent-dots i {
        background: #2f6fed;
        border-radius: 999px;
        display: block;
        height: 24px;
        width: 24px;
    }

    .UFOV-brain-games__orbit button {
        left: var(--x0);
        opacity: 1;
        top: var(--y0);
        transition: background-color 180ms ease, box-shadow 180ms ease, scale 180ms ease;
    }

    .UFOV-brain-games__orbit.is-track button {
        animation: UFOV-orbit-motion var(--orbit-duration) linear forwards;
    }

    .UFOV-brain-games__orbit.is-answer button,
    .UFOV-brain-games__orbit.is-feedback button {
        left: var(--x3);
        top: var(--y3);
    }

    .UFOV-brain-games__matrix-token i.is-filled {
        background: var(--matrix-tone);
        border-color: var(--matrix-tone);
    }

    .UFOV-brain-games__blink-options button.is-picked {
        background: #dbeafe;
        border-color: #2f6fed;
        box-shadow: 0 0 0 4px rgba(47, 111, 237, 0.16);
        color: #1e4fa3;
    }

    .UFOV-brain-games__blink-options button.is-correct {
        background: #e5f8ef;
        border-color: #20a46b;
        box-shadow: 0 0 0 4px rgba(32, 164, 107, 0.16);
        color: #176f4a;
    }

    .UFOV-brain-games__blink-options button.is-picked.is-wrong {
        background: #ffe7ec;
        border-color: #e95569;
        box-shadow: 0 0 0 4px rgba(233, 85, 105, 0.14);
        color: #9b304a;
    }

    .UFOV-brain-games__line-game {
        min-height: 260px;
    }

    .UFOV-brain-games__line-reference,
    .UFOV-brain-games__line-options {
        animation: UFOV-line-enter 240ms ease both;
    }

    .UFOV-brain-games__line-transition {
        display: block;
        height: 260px;
        width: 100%;
    }

    .UFOV-brain-games__rain-game {
        gap: 28px;
        width: min(350px, 100%);
    }

    .UFOV-brain-games__rain-equation {
        border-radius: 22px;
        font-size: clamp(42px, 13vw, 58px);
        height: 142px;
        width: min(280px, 82vw);
    }

    .UFOV-brain-games__order-game {
        gap: 24px;
        width: min(354px, 100%);
    }

    .UFOV-brain-games__order-queue {
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }

    .UFOV-brain-games__order-slot {
        background: transparent;
        border: 0;
        box-shadow: none;
        opacity: 1;
        perspective: 700px;
    }

    .UFOV-brain-games__order-slot-inner {
        display: block;
        height: 100%;
        position: relative;
        transform-style: preserve-3d;
        transition: transform 520ms cubic-bezier(0.2, 0.8, 0.2, 1);
        width: 100%;
    }

    .UFOV-brain-games__order-game.is-input .UFOV-brain-games__order-slot-inner,
    .UFOV-brain-games__order-game.is-feedback .UFOV-brain-games__order-slot-inner {
        transform: rotateY(180deg);
    }

    .UFOV-brain-games__order-face {
        align-items: center;
        backface-visibility: hidden;
        background: #ffffff;
        border: 1px solid rgba(31, 41, 55, 0.08);
        border-radius: 16px;
        box-shadow: 0 10px 22px rgba(31, 41, 55, 0.08);
        display: flex;
        inset: 0;
        justify-content: center;
        position: absolute;
    }

    .UFOV-brain-games__order-face.is-back {
        background: #2f6fed;
        transform: rotateY(180deg);
    }

    .UFOV-brain-games__order-slot.is-done .UFOV-brain-games__order-face.is-back {
        background: #20a46b;
    }

    .UFOV-brain-games__order-face.is-back::after {
        background: url('/assets/ufov/sopt-mark-white.svg') center / contain no-repeat;
        content: '';
        height: 36%;
        width: 36%;
    }

    .UFOV-brain-games__order-item:disabled,
    .UFOV-brain-games__catch-tile:disabled {
        opacity: 1;
    }

    .UFOV-brain-games__catch-grid {
        width: min(330px, 100%);
    }

    .UFOV-brain-games__catch-grid.is-4 {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        width: min(280px, 82vw);
    }

    .UFOV-brain-games__catch-grid.is-5,
    .UFOV-brain-games__catch-grid.is-6 {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    .UFOV-brain-games__catch-tile {
        overflow: hidden;
        perspective: 700px;
    }

    .UFOV-brain-games__catch-tile-inner {
        align-items: center;
        display: flex;
        height: 100%;
        justify-content: center;
        transition: transform 480ms cubic-bezier(0.2, 0.8, 0.2, 1);
        width: 100%;
    }

    .UFOV-brain-games__catch-game.is-answer .UFOV-brain-games__catch-tile-inner {
        animation: UFOV-catch-flip 480ms cubic-bezier(0.2, 0.8, 0.2, 1);
    }

    .UFOV-brain-games__go-deck-game {
        align-content: center;
        display: grid;
        gap: 24px;
        justify-items: center;
        min-height: 0;
        width: 100%;
    }

    .UFOV-brain-games__go-rule {
        color: #8a94a3;
        font-size: 16px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 1.25;
        margin: 0;
        padding-bottom: 20px;
        text-align: center;
    }

    .UFOV-brain-games__go-rule strong {
        color: #596474;
        font-weight: 600;
    }

    .UFOV-brain-games__go-deck {
        aspect-ratio: 5 / 7;
        isolation: isolate;
        margin-top: 0;
        position: relative;
        width: min(60vw, 230px);
    }

    .UFOV-brain-games__go-card-back,
    .UFOV-brain-games__go-active-card {
        border-radius: 8px;
        inset: 0;
        position: absolute;
    }

    .UFOV-brain-games__go-card-back {
        box-shadow: 0 12px 24px rgba(31, 41, 55, 0.1);
        overflow: hidden;
    }

    .UFOV-brain-games__go-card-back svg,
    .UFOV-brain-games__go-active-card svg {
        display: block;
        height: 100%;
        width: 100%;
    }

    .UFOV-brain-games__go-card-back.is-layer-3 {
        transform: translate(18px, -18px) rotate(4deg);
        z-index: 1;
    }

    .UFOV-brain-games__go-card-back.is-layer-2 {
        transform: translate(12px, -12px) rotate(2.5deg);
        z-index: 2;
    }

    .UFOV-brain-games__go-card-back.is-layer-1 {
        transform: translate(6px, -6px) rotate(1deg);
        z-index: 3;
    }

    .UFOV-brain-games__go-active-card {
        animation: UFOV-go-card-deal 280ms cubic-bezier(0.2, 0.8, 0.2, 1);
        box-shadow: 0 22px 38px rgba(31, 41, 55, 0.14);
        overflow: hidden;
        transition:
            box-shadow 180ms ease,
            transform 180ms ease;
        will-change: opacity, transform;
        z-index: 4;
    }

    .UFOV-brain-games__go-active-card::after {
        border-radius: inherit;
        content: '';
        inset: 0;
        pointer-events: none;
        position: absolute;
        transition: background-color 180ms ease, box-shadow 180ms ease;
    }

    .UFOV-brain-games__go-active-card.is-good,
    .UFOV-brain-games__go-active-card.is-hit {
        box-shadow: 0 22px 38px rgba(32, 164, 107, 0.2);
    }

    .UFOV-brain-games__go-active-card.is-good {
        transform: scale(0.98);
    }

    .UFOV-brain-games__go-active-card.is-hit {
        animation: UFOV-go-card-fly 650ms cubic-bezier(0.22, 0.7, 0.24, 1) forwards;
    }

    .UFOV-brain-games__go-active-card.is-good::after,
    .UFOV-brain-games__go-active-card.is-hit::after {
        background: rgba(53, 182, 122, 0.16);
        box-shadow: inset 0 0 0 5px #35b67a;
    }

    .UFOV-brain-games__go-active-card.is-missed-target,
    .UFOV-brain-games__go-active-card.is-false-press {
        box-shadow: 0 22px 38px rgba(233, 85, 105, 0.18);
    }

    .UFOV-brain-games__go-active-card.is-missed-target {
        animation: UFOV-go-card-shake 560ms ease-in-out;
    }

    .UFOV-brain-games__go-active-card.is-false-press {
        transform: scale(0.98);
    }

    .UFOV-brain-games__go-active-card.is-missed-target::after,
    .UFOV-brain-games__go-active-card.is-false-press::after {
        background: rgba(233, 85, 105, 0.16);
        box-shadow: inset 0 0 0 5px #e95569;
    }

    .UFOV-brain-games__go-press {
        align-items: center;
        background: #111827;
        border: 0;
        border-radius: 8px;
        box-shadow: 0 16px 28px rgba(17, 24, 39, 0.18);
        color: #ffffff;
        display: flex;
        font-size: 17px;
        font-weight: 600;
        height: 62px;
        justify-content: center;
        letter-spacing: 0;
        padding: 0;
        width: min(72vw, 230px);
    }

    .UFOV-brain-games__go-press:disabled {
        cursor: default;
        opacity: 0.72;
    }

    @keyframes UFOV-orbit-motion {
        0% { left: var(--x0); top: var(--y0); }
        33% { left: var(--x1); top: var(--y1); }
        66% { left: var(--x2); top: var(--y2); }
        100% { left: var(--x3); top: var(--y3); }
    }

    @keyframes UFOV-catch-flip {
        0% { transform: rotateY(0); }
        50% { transform: rotateY(90deg); }
        100% { transform: rotateY(0); }
    }

    @keyframes UFOV-go-card-deal {
        0% { opacity: 0; transform: translate(16px, -28px) rotate(3deg) scale(0.92); }
        70% { opacity: 1; transform: translate(-2px, 3px) rotate(-0.5deg) scale(1.01); }
        100% { opacity: 1; transform: translate(0) rotate(0) scale(1); }
    }

    @keyframes UFOV-go-card-fly {
        0% { opacity: 1; transform: translate(0) rotate(0) scale(1); }
        18% { opacity: 1; transform: translate(-8px, 8px) rotate(-2deg) scale(0.97); }
        100% { opacity: 0; transform: translate(110%, -72%) rotate(18deg) scale(0.82); }
    }

    @keyframes UFOV-go-card-shake {
        0%, 100% { transform: translateX(0) rotate(0); }
        15% { transform: translateX(-11px) rotate(-1.4deg); }
        30% { transform: translateX(10px) rotate(1.2deg); }
        45% { transform: translateX(-8px) rotate(-1deg); }
        60% { transform: translateX(7px) rotate(0.8deg); }
        75% { transform: translateX(-4px) rotate(-0.5deg); }
        88% { transform: translateX(3px) rotate(0.3deg); }
    }

    @keyframes UFOV-line-enter {
        from { opacity: 0; transform: scale(0.96); }
        to { opacity: 1; transform: scale(1); }
    }

    @keyframes UFOV-balance-settle {
        0%, 100% { transform: translateY(0) scale(1); }
        42% { transform: translateY(3px) scale(0.985); }
        72% { transform: translateY(-1px) scale(1.005); }
    }

    @keyframes UFOV-balance-wobble {
        0%, 100% { transform: translateX(0); }
        25% { transform: translateX(-6px); }
        50% { transform: translateX(5px); }
        75% { transform: translateX(-3px); }
    }

    @media (max-width: 400px), (max-height: 740px) {
        .UFOV-brain-games__shelf-game,
        .UFOV-brain-games__balance-game,
        .UFOV-brain-games__percent-game { gap: 16px; }
        .UFOV-brain-games__balance-scale { height: 178px; }
        .UFOV-brain-games__balance-stand { bottom: 15px; }
        .UFOV-brain-games__percent-game > strong { height: 76px; width: 76px; }
        .UFOV-brain-games__go-deck-game { gap: 18px; }
        .UFOV-brain-games__go-rule { padding-bottom: 24px; }
        .UFOV-brain-games__go-deck { width: min(55vw, 208px); }
        .UFOV-brain-games__go-press { height: 58px; width: min(70vw, 220px); }
    }
`;
